import { LInputField } from "@components";
import { searchRemoteAssessmentsFilter } from "@fadmin/tabs/results/components/filterHelper";
import { RemoteAssessment } from "@store/locationsSlice";
import { ChangeEvent, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { LeftSide } from "./LeftSide";
import { RightSide } from "../right-side/RightSide";

export const RemoteAssessments = ({ assessments, onClick }: RemoteAssessmentsProps): JSX.Element => {
    const validateMethods = useForm();

    const [selectedRemoteAssessment, setSelectedRemoteAssessment] = useState<RemoteAssessment>();
    const [searchValue, setSearchValue] = useState("");

    const handleSelectExaminee = (remoteAssessment: RemoteAssessment): void => {
        setSelectedRemoteAssessment(remoteAssessment);
    };

    const handleSearch = (e: ChangeEvent<HTMLInputElement>): void => {
        setSearchValue(e.target.value);
    };

    const filteredExaminees = searchRemoteAssessmentsFilter(searchValue, assessments);

    return (
        <div>
            <div className="is-flex is-justify-content-space-between is-align-items-center mb-5">
                <div className="mx-6 minw-40">
                    <FormProvider {...validateMethods}>
                        <LInputField
                            inputName="search"
                            placeholder="Search examinees"
                            isSearch={true}
                            onChange={handleSearch}
                            isExpanded
                            isRounded
                            hideErrorLabel
                        />
                    </FormProvider>
                </div>
                <div />
            </div>
            <div className="columns">
                <LeftSide assessments={filteredExaminees} handleSelectExaminee={handleSelectExaminee} />
                <RightSide upcomingAssessment={selectedRemoteAssessment} completed />
            </div>
        </div>
    );
};

interface RemoteAssessmentsProps {
    assessments: RemoteAssessment[];
    onClick: () => void;
}
